// @ts-nocheck
import React from 'react';
import { Phone, Clock } from 'lucide-react';

export function CallStatsCard({ stats }) {
  if (!stats) return null;

  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <>
      {/* 総通話数 */}
      <div className="bg-white p-6 rounded-lg shadow">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">総通話数</p>
            <p className="text-3xl font-bold mt-2">{stats.totalCalls || 0}</p>
          </div>
          <div className="p-3 bg-purple-100 rounded-full">
            <Phone className="text-purple-600" size={24} />
          </div>
        </div>
      </div>

      {/* 平均通話時間 */}
      <div className="bg-white p-6 rounded-lg shadow">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">平均通話時間</p>
            <p className="text-3xl font-bold mt-2">
              {formatDuration(stats.avgDuration || 0)}
            </p>
          </div>
          <div className="p-3 bg-orange-100 rounded-full">
            <Clock className="text-orange-600" size={24} />
          </div>
        </div>
      </div>
    </>
  );
}
